module.exports = __webpack_public_path__ + "static/img/index1.fe59267.gif";


//////////////////
// WEBPACK FOOTER
// ./static/img/index/index1.gif
// module id = jcHg
// module chunks = 1